import {Route} from '@angular/router';
import {AuthGuardService} from './services/auth-guard.service';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home-page/home-page.component').then(m => m.HomePageComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    path: 'users',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/users-page/users-page.component').then(m => m.UsersPageComponent),
  },
  {
    path: 'bands',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/bands-page/bands-page.component').then(m => m.BandsPageComponent),
  },
  {
    path: 'events',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/events-page/events-page.component').then(m => m.EventsPageComponent),
  },
  {
    path: 'feedbacks',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/feedbacks-page/feedbacks-page.component').then(m => m.FeedbacksPageComponent),
  },
  {
    path: 'push',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/push-page/push-page.component').then(m => m.PushPageComponent),
  },
  {
    path: 'special-campaigns',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/special-campaigns-page/special-campaigns-page.component').then(m => m.SpecialCampaignsPageComponent),
  },
  {
    path: 'settings',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/settings-page/settings-page.component').then(m => m.SettingsPageComponent),
  },
];
